<div class="breadcrumb">
    <div class="container">
        <a routerLink="/">{{ 'Home' | translate }}</a> > {{ 'Desempenho por Revisor' | translate}}
    </div>
</div>

<main class="container">
    <div class="consolidado-header">
        <h2>{{ 'Desempenho por Revisor' | translate }}</h2>
        <div class="consolidado-filtros">
            <div class="filtro">
                <label for="cboPais">{{ 'País' | translate }}</label>
                <select id="cboPais" [ngModel]="filtro.pais" (ngModelChange)="onPaisChange($event)">
                    <option value="">{{ 'Selecione' | translate }}</option>
                    <option *ngFor="let pais of listaPaises" [value]="pais.id">{{ pais.name | translate }}</option>
                </select>
            </div>

            <div class="filtro">
                <label for="cboAno">{{ 'Ano' | translate }}</label>
                <select id="cboAno" [(ngModel)]="filtro.ano">
                    <option value="">{{ 'Selecione' | translate }}</option>
                    <option *ngFor="let ano of listAnos" [value]="ano">{{ ano }}</option>
                </select>
            </div>

            <div class="filtro">
                <label for="cboMes">{{ 'Mês' | translate }}</label>
                <select id="cboMes" [(ngModel)]="filtro.mes">
                    <option value="">{{ 'Selecione' | translate }}</option>
                    <option *ngFor="let mes of listMeses" [value]="mes.value">{{ mes.label | translate }}</option>
                </select>
            </div>

            <div class="filtro">
                <label for="dataInicial">{{ 'Data Inicial' | translate }}</label>
                <input type="text" id="dataInicial" placeholder="dd/mm/aaaa" maxlength="10"
                       [ngModel]="filtro.dataInicial" (input)="formatarDataInput($event, 'dataInicial')" />
            </div>

            <div class="filtro">
                <label for="dataFinal">{{ 'Data Final' | translate }}</label>
                <input type="text" id="dataFinal" placeholder="dd/mm/aaaa" maxlength="10"
                       [ngModel]="filtro.dataFinal" (input)="formatarDataInput($event, 'dataFinal')" />
            </div>

            <div class="filtro">
                <label for="cboGrupo">{{ 'Grupo' | translate }}</label>
                <select id="cboGrupo" [ngModel]="filtro.groupId" (ngModelChange)="onGrupoChange($event)">
                    <option value="">{{ 'Todos' | translate }}</option>
                    <option *ngFor="let g of listGrupos" [value]="g.id">{{ g.name }}</option>
                </select>
            </div>

            <div class="filtro" *ngIf="isAdmin || isAdminGrupo || isAdminGlobalGrupo">
                <label for="cboUsuario">{{ 'Usuário' | translate }}</label>
                <select id="cboUsuario" [(ngModel)]="filtro.usuario">
                    <option value="">{{ 'Todos' | translate }}</option>
                    <option *ngFor="let usuario of listaUsuarios" [value]="usuario.email">{{ usuario.email }}</option>
                </select>
            </div>

            <div class="filtro-acoes">
                <button class="btn-buscar" (click)="atualizaFiltro()">
                    <span i18n="@@dashboard.btn.consultar">Consultar</span>
                </button>

                <button class="btn-limpar" (click)="clearFiltros()">
                    <span i18n="@@dashboard.btn.limpar">Limpar</span>
                </button>

                <button class="btn-exportar" (click)="exportToExcel()" *ngIf="filteredData.length > 0">
                    <span i18n="@@dashboard.btn.exportarCsv">↓ Exportar CSV</span>
                </button>
            </div>
        </div>
    </div>

    <div *ngIf="filtroError" class="filtro-error">
        {{ filtroError }}
    </div>

    <div class="consolidado-table-wrap">
        <table class="consolidado-table">
            <thead>
                <tr class="col-header-row">
                    <th>{{ 'País' | translate }}</th>
                    <th>{{ 'Grupo' | translate }}</th>
                    <th>{{ 'Usuário' | translate }}</th>
                    <th>{{ 'Mês' | translate }}</th>
                    <th>{{ 'Data' | translate }}</th>
                    <th>{{ 'Total Rxs' | translate }}</th>
                    <th>{{ 'Impresas' | translate }}</th>
                    <th>{{ 'Manuscritas' | translate }}</th>
                    <th>{{ 'Total Pxs' | translate }}</th>
                    <th>{{ 'Total Interacoes.' | translate }}</th>
                    <th>{{ 'Hora Início' | translate }}</th>
                    <th>{{ 'Hora Fim' | translate }}</th>
                    <th>{{ 'Tempo Neto' | translate }}</th>
                    <th>{{ 'Tempo x Rxs' | translate }}</th>
                    <th>{{ 'Tempo Transición' | translate }}</th>
                    <th>{{ 'Prom Rxs/h' | translate }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of filteredData; let i = index; trackBy: trackByItem"
                    [class.row-alt]="i % 2 !== 0">
                    <td>{{ item.nomePais }}</td>
                    <td>{{ item.grupo }}</td>
                    <td>{{ item.emailRevisor }}</td>
                    <td>{{ item.mes }}</td>
                    <td>{{ item.dataRevisao }}</td>
                    <td class="num">{{ item.totalReceitas | number }}</td>
                    <td class="num">{{ item.impresas | number }}</td>
                    <td class="num">{{ item.manuscritas | number }}</td>
                    <td class="num">{{ item.totalPxs | number }}</td>
                    <td class="num">{{ item.totalInteracoes | number }}</td>
                    <td class="num">{{ item.horaInicio }}</td>
                    <td class="num">{{ item.horaFim }}</td>
                    <td class="num">{{ item.tempoNeto }}</td>
                    <td class="num">{{ item.tempoXRxs }}</td>
                    <td class="num">{{ item.tempoTransicao }}</td>
                    <td class="num">{{ item.promRxsHora | number:'1.1-1' }}</td>
                </tr>
                <tr *ngIf="filteredData.length === 0" class="row-empty">
                    <td colspan="16" class="empty-msg">{{ 'Nenhum dado encontrado' | translate }}</td>
                </tr>
            </tbody>
            <tfoot *ngIf="filteredData.length > 0">
                <tr class="total-row">
                    <td colspan="5" i18n="@@dashboard.total">Total</td>
                    <td class="num">{{ totais.totalReceitas | number }}</td>
                    <td class="num">{{ totais.impresas | number }}</td>
                    <td class="num">{{ totais.manuscritas | number }}</td>
                    <td class="num">{{ totais.totalPxs | number }}</td>
                    <td class="num">{{ totais.totalInteracoes | number }}</td>
                    <td colspan="6"></td>
                </tr>
            </tfoot>
        </table>
    </div>
</main>
